import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "pa-4",
    style: _normalizeStyle({ backgroundColor: _ctx.cardBg })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "text-h6" }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Configurare AD ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_v_divider, { class: "my-2" }),
      _createVNode(_component_DxDataGrid, {
        ref: "dataGridRef",
        "data-source": _ctx.adSettings,
        "show-borders": true,
        "show-column-lines": false,
        "show-row-lines": true,
        "row-alternation-enabled": true,
        "hover-state-enabled": true,
        "column-auto-width": true,
        "allow-column-reordering": true,
        "allow-column-resizing": true,
        "remote-operations": false,
        onRowInserting: _ctx.onRowInserting,
        onRowUpdating: _ctx.onRowUpdating,
        onRowRemoving: _ctx.onRowRemoving
      }, {
        testCell: _withCtx(({ data }) => [
          _createVNode(_component_DxButton, {
            text: "Testează AD",
            icon: "link",
            "styling-mode": "outlined",
            onClick: ($event: any) => (_ctx.testAd(data.data))
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxSearchPanel, {
            visible: true,
            placeholder: "Caută..."
          }),
          _createVNode(_component_DxColumnChooser, { enabled: true }),
          _createVNode(_component_DxPaging, { "page-size": 10 }),
          _createVNode(_component_DxPager, {
            "show-page-size-selector": true,
            "allowed-page-sizes": [10,20,50],
            "show-info": ""
          }),
          _createVNode(_component_DxEditing, {
            "allow-updating": true,
            "allow-adding": true,
            "allow-deleting": true,
            mode: "popup"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxPopup, {
                title: "Configurare AD",
                "show-title": true,
                width: 560,
                height: "auto",
                "wrapper-attr": { class: 'era-edit-popup' }
              }),
              _createVNode(_component_DxForm, { "col-count": 2 })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Hostname",
            caption: "Server (host)"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Port",
            caption: "Port",
            width: 90
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "UserName",
            caption: "Utilizator"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PasswordCipher",
            caption: "Parolă",
            "customize-text": _ctx.maskPass,
            "editor-options": { mode: 'password' }
          }, null, 8, ["customize-text"]),
          _createVNode(_component_DxColumn, {
            "data-field": "Domain",
            caption: "Domeniu"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DomainName",
            caption: "Nume domeniu"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DomainDistinguishedName",
            caption: "Domeniu (DN)",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "SearchBase",
            caption: "Search Base",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ContainerName",
            caption: "Container",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "SearchProperty",
            caption: "Proprietate căutare",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            caption: "",
            width: 140,
            "cell-template": "testCell"
          })
        ]),
        _: 1
      }, 8, ["data-source", "onRowInserting", "onRowUpdating", "onRowRemoving"])
    ]),
    _: 1
  }, 8, ["style"]))
}